// @flow

import React from 'react';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';

import Counter from './Counter';
import './index.scss';

type Props = {
  startDate: string,
}

const Countdown = ({
  startDate,
}: Props) => (
  <div className="virtual-event__countdown">
    <div className="virtual-event__countdown__header">
      <div className="virtual-event__countdown__header__label">
        <L10nMessage id="page.event.virtualEvent.raceNotStart.label" />
      </div>
      <Counter
        onTimeUp={() => { window.location.reload(); }}
        className="virtual-event__countdown__header__counter"
        dateToCompare={new Date(startDate).getTime()} />
    </div>
    <div className="virtual-event__countdown__description container">
      <L10nMessage id="page.event.virtualEvent.raceNotStart.description" />
    </div>
  </div>
);

export default Countdown;
